export const GET_BANK_OPERATIONS = "GET_BANK_OPERATIONS";
export const GET_BANK_OPERATIONS_COMPLETED = "GET_BANK_OPERATIONS_COMPLETED";
export const GET_BANK_OPERATIONS_FAILED = "GET_BANK_OPERATIONS_FAILED";

export const CHANGE_BANK_CATEGORIE = "CHANGE_BANK_CATEGORIE";
export const RAPPROCHER_BANK_OPERATION = "RAPPROCHER_BANK_OPERATION";
export const EXPORT_BANK_FLUX = "EXPORT_BANK_FLUX";

// Valide la catégorie de flux sélectionnés (réception -> catégorisés).
// Optionnellement force une catégorie commune avant validation.
export const validerCategorieBankOperations = (operationIds, categorie = null) => ({
  type: "VALIDER_CATEGORIE_BANK_OPERATIONS",
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/valider-categorie.json`,
    method: "POST",
    body: { operationIds: operationIds || [], categorie: categorie || null },
  },
});

// Renvoie des flux catégorisés vers la boîte de réception (dé-validation).
export const devaliderCategorieBankOperations = (operationIds) => ({
  type: "DEVALIDER_CATEGORIE_BANK_OPERATIONS",
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/devalider-categorie.json`,
    method: "POST",
    body: { operationIds: operationIds || [] },
  },
});

// ── Règles de catégorisation (admin) ──
export const getBankRegles = () => ({
  type: "GET_BANK_REGLES",
  meta: { async: true, blocking: true, path: `/api/v2/admin/bank/regles.json`, method: "GET" },
});

export const createBankRegle = (regle) => ({
  type: "CREATE_BANK_REGLE",
  meta: { async: true, blocking: true, path: `/api/v2/admin/bank/regles.json`, method: "POST", body: regle },
});

export const updateBankRegle = (id, regle) => ({
  type: "UPDATE_BANK_REGLE",
  meta: { async: true, blocking: true, path: `/api/v2/admin/bank/regles/${id}.json`, method: "POST", body: regle },
});

export const deleteBankRegle = (id) => ({
  type: "DELETE_BANK_REGLE",
  meta: { async: true, blocking: true, path: `/api/v2/admin/bank/regles/${id}/supprimer.json`, method: "POST", body: {} },
});

export const reappliquerBankRegles = () => ({
  type: "REAPPLIQUER_BANK_REGLES",
  meta: { async: true, blocking: true, path: `/api/v2/admin/bank/regles/reappliquer.json`, method: "POST", body: {} },
});

// Liste des crédits du dernier import + stats + familles + catégories.
// Filtres : phase ('RECEPTION'|'CATEGORISE'|'TRAITE'), famille, search.
export const getBankOperations = (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters || {}).filter(([, v]) => v !== null && v !== undefined && v !== "")
  );
  return {
    type: GET_BANK_OPERATIONS,
    meta: {
      async: true,
      blocking: true,
      path: `/api/v2/admin/bank/operations.json`,
      method: "GET",
      params,
    },
  };
};

export const changeBankCategorie = (id, categorie) => ({
  type: CHANGE_BANK_CATEGORIE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/operations/${id}/categorie.json`,
    method: "POST",
    body: { categorie },
  },
});

// Valide le rapprochement d'un crédit avec une commande : marque la facture
// payée (paiement VosFactures + statut 203) et catégorise en paiement client.
export const rapprocherBankOperation = (id, { commandeId, paidDate } = {}) => ({
  type: RAPPROCHER_BANK_OPERATION,
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/operations/${id}/rapprocher.json`,
    method: "POST",
    body: { commande_id: commandeId || null, paid_date: paidDate || null },
  },
});

// Recherche de factures à rattacher manuellement (n° facture, n° commande, client).
export const searchFactures = (q) => ({
  type: "SEARCH_FACTURES",
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/recherche-facture.json`,
    method: "GET",
    params: { q },
  },
});

// Rattache un crédit à une facture SANS paiement (facture déjà réglée).
export const lierBankOperation = (id, { type, commandeId, numbering } = {}) => ({
  type: "LIER_BANK_OPERATION",
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/operations/${id}/lier.json`,
    method: "POST",
    body: { type, commande_id: commandeId || null, numbering: numbering || null },
  },
});

// Annule le traitement d'un flux (onglet « Flux traité ») : annule l'export
// et/ou un rattachement manuel pour le renvoyer dans sa famille (ré-exportable).
export const annulerTraitementBankOperation = (id) => ({
  type: "ANNULER_TRAITEMENT_BANK_OPERATION",
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/operations/${id}/annuler-traitement.json`,
    method: "POST",
    body: {},
  },
});

// Annule le traitement de plusieurs flux sélectionnés (bulk).
export const annulerTraitementBankOperations = (operationIds) => ({
  type: "ANNULER_TRAITEMENT_BANK_OPERATIONS",
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/annuler-traitement.json`,
    method: "POST",
    body: { operationIds: operationIds || [] },
  },
});

// Export de tous les flux (hors paiements clients) vers le classeur dédié,
// un onglet par famille (TR / Aides & prévoyance / Remb. fournisseurs / Autres).
export const exportBankFlux = () => ({
  type: EXPORT_BANK_FLUX,
  meta: {
    async: true,
    blocking: true,
    path: `/api/v2/admin/bank/export-flux.json`,
    method: "POST",
    body: {},
  },
});
